import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  @Output()
  openChatEvent = new EventEmitter<void>();

  clickOpenChat() {
    this.openChatEvent.emit();
  }
}
